import { cB as e, cNotM as o, cM as i } from "./ghl-ui.es361.js";
const t = e("ellipsis", {
  overflow: "hidden"
}, [o("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), i("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), i("cursor-pointer", `
 cursor: pointer;
 `)]);
export {
  t as default
};
